import { render, staticRenderFns } from "./User.vue?vue&type=template&id=dd92eb4e&scoped=true&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"
import style0 from "./User.vue?vue&type=style&index=0&id=dd92eb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd92eb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd92eb4e')) {
      api.createRecord('dd92eb4e', component.options)
    } else {
      api.reload('dd92eb4e', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=dd92eb4e&scoped=true&", function () {
      api.rerender('dd92eb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/User.vue"
export default component.exports